import React from 'react';
import { Icon } from 'antd';
import IntlMessages from '../../../../../helpers/intlMessages';
/**
 * checks the entered password value for at
 * least 8 characters & updates user feedback
 * as user types into new password input
 */
class CharacterLengthFeedbackItem extends React.Component {
  render() {
    const { input, value } = this.props;

    let feedbackType;
    let iconType;

    if (value) {
      const check = value.length >= 8;
      feedbackType = check ? 'success' : 'error';
      iconType = check ? 'check' : 'close';
    }

    return (
      <div className={input ? `input-password-feedback ${feedbackType}` : 'input-password-feedback'}>
        <Icon type={input ? `${iconType}-circle` : 'exclamation-circle'} />
        <IntlMessages id="passwordFeedback.length" />
      </div>
    );
  }
}

export default CharacterLengthFeedbackItem;
